import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";

type RequestType = {
  usuarioLogadoId: string | null;
  onSuccess: () => void;
};

export const usePostCriarAutenticacaoPartnerContaDigital = (request: RequestType) => {
  const onSuccess = () => {
    request.onSuccess();
    queryClient.invalidateQueries(["adm-possui-autenticacao-partner-conta-digital"]);
  };

  const onError = () => {
    toast.error("Erro ao criar autenticação com a conta digital do Partner Bank");
  };

  return usePost<string | null>({
    url: api.contaDigital.postCriarAutenticacaoPartnerContaDigital,
    pathVariables: request.usuarioLogadoId || undefined,
    onSuccess,
    onError,
  });
};
